import type { ComponentProps } from 'react';
import { chakra } from '@chakra-ui/react';

type LogoProps = Omit<ComponentProps<typeof chakra.img>, 'src'> & {
  src?: string;
};

export const Logo = ({
  src = '/assets/images/volyx-text-img.png',
  alt = 'Volyx',
  ...props
}: LogoProps) => {
  return (
    <chakra.img
      src={src}
      alt={alt}
      w="200px"
      h="50px"
      mb="10"
      objectFit="contain"
      style={{
        filter:
          'brightness(0) saturate(100%) invert(13%) sepia(8%) saturate(1000%) hue-rotate(180deg) brightness(95%) contrast(95%)',
        ...(props.style ?? {}),
      }}
      {...props}
    />
  );
};
